<template>
  <div class="frame5">
    <div class="frame5_top_title">
      <img
        src="../../../../public/img/shares_Info/vip2.png"
        class="frame5_top_img1"
      />
      免费体验次数已用完
      <img
        src="../../../../public/img/shares_Info/close.png"
        class="frame5_top_img2"
      />
    </div>
    <div class="frame5_content">
      开通小钱书VIP，立即掌握行情,想看就看，快人一步!更有智能选股、钱术解析等专属特权
    </div>
    <div class="frame5_title2">
      <div></div>
      小钱书VIP专属特权
      <div></div>
    </div>
    <div class="frame5_tequan">
      <div class="frame5_tequan_options1">
        <img src="../../../../public/img/shares_Info/icon_1_1.png" alt="" />
        股债基风险亮点
      </div>
      <div class="frame5_tequan_options1">
        <img src="../../../../public/img/shares_Info/icon_1_2.png" alt="" />
        智能选股智能选基
      </div>
      <div class="frame5_tequan_options1">
        <img src="../../../../public/img/shares_Info/icon_1_3.png" alt="" />
        钱术项目解析
      </div>
      <div class="frame5_tequan_options1">
        <img src="../../../../public/img/shares_Info/icon_1_4.png" alt="" />
        专属研报财报
      </div>
    </div>
    <div class="frame5_bottom">
      <div class="frame5_bottom_text2">开通小钱书VIP</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.frame5 {
  width: 261px;
  height: 341px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  position: fixed;
  top: calc(50% - 119px);
  left: calc(50% - 160px);
  z-index: 9999999;
  padding: 28px 28px 28px 35px;
}
.frame5_top_title {
  width: 100%;
  text-align: center;
  color: #e7aa55;
  font-size: 20px;
  font-weight: 550;
  position: relative;
  line-height: 1;
}
.frame5_top_img1 {
  width: 23px;
  height: 20px;
  vertical-align: middle;
}
.frame5_top_img2 {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-left: 10px;
  position: absolute;
  right: -7px;
  top: 4px;
}
.frame5_content {
  font-size: 18px;
  line-height: 1.8;
  color: #625543;
  letter-spacing: 0px;
  margin-top: 25px;
}
.frame5_bottom {
  margin-top: 35px;
}
.frame5_bottom_text2 {
  width: 194px;
  height: 42px;
  background-image: linear-gradient(-20deg, #e1a859 0%, #ffc370 100%),
    linear-gradient(#000000, #000000);
  background-blend-mode: normal, normal;
  border-radius: 21px;
  font-size: 18px;
  line-height: 42px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.frame5_title2 {
  font-size: 17px;
  line-height: 1;
  color: #e7aa55;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}
.frame5_title2 div {
  width: 43px;
  height: 0;
  border-bottom: 1px solid #e7aa55;
  margin-top: 8px;
}
.frame5_tequan {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
}
.frame5_tequan_options1 {
  width: 50%;
  font-size: 14px;
  line-height: 1;
  color: #625543;
  margin-top: 13px;
}
.frame5_tequan_options1 img{
  width: 14px;
  height: 15px;
}
</style>